if (!customElements.get('card-carousel')) {
  customElements.define(
    'card-carousel',
    class CardCarousel extends HTMLElement {
      constructor() {
        super()

        document.addEventListener('DOMContentLoaded', this.load.bind(this))

        if (Shopify.designMode) {
          this.closest('[id*="shopify-section-template"]').addEventListener(
            'shopify:section:load',
            () => {
              if (!this.carousel) {
                this.load()
                return
              }

              this.carousel.reInit()
            }
          )
        }
      }

      /**
       * Loads all the required methods.
       */
      load() {
        this.setNodeSelectors()
        this.constructCarousel()
        this.setCarouselEvents()
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          viewport: this.querySelector('[js-card-carousel="viewport"]'),
          dots: this.querySelector('[js-card-carousel="dots"]'),
        }
      }

      /**
       * Constructs the carousel instance.
       */
      constructCarousel() {
        this.carousel = EmblaCarousel(
          this,
          {
            container: this.nodeSelectors.viewport,
            breakpoints: {
              '(min-width: 1024px)': {
                slidesToScroll: 4,
              },
            },
          },
          [
            EmblaCarouselAutoHeight({
              destroyHeight: 'auto',
            }),
          ]
        )
      }

      /**
       * Sets the carousel event listeners.
       */
      setCarouselEvents() {
        this.carousel.on('destroy', this.constructDots())
      }

      /**
       * Adds the dot elements to the carousel.
       */
      constructDots() {
        let nodes = []

        /**
         * Constructs the actual dot elements.
         */
        const addDotElements = () => {
          const snapList = this.carousel.scrollSnapList()

          this.nodeSelectors.dots.innerHTML = snapList
            .map(() => '<button js-card-carousel="dot" type="button"></button>')
            .join('')

          if (snapList.length <= 1) {
            this.nodeSelectors.dots.classList.add('sr-only')
          } else {
            this.nodeSelectors.dots.classList.remove('sr-only')
          }

          nodes = Array.from(
            this.nodeSelectors.dots.querySelectorAll('[js-card-carousel="dot"]')
          )

          nodes.forEach((dot, index) => {
            dot.addEventListener(
              'click',
              () => this.carousel.scrollTo(index),
              false
            )
          })
        }

        /**
         * Sets the active states of the dots.
         */
        const setDotStates = () => {
          nodes[this.carousel.previousScrollSnap()].classList.remove(
            'is-active'
          )
          nodes[this.carousel.selectedScrollSnap()].classList.add('is-active')
        }

        this.carousel
          .on('init', addDotElements)
          .on('reInit', addDotElements)
          .on('init', setDotStates)
          .on('reInit', setDotStates)
          .on('select', setDotStates)
          .on('resize', setDotStates)

        return () => {
          dotsNode.innerHTML = ''
        }
      }
    }
  )
}
